export interface KeroStatus {
  state: "external" | "starting" | "running" | "failed" | "stopped";
  pid: number | null;
  lastExitCode: number | null;
  restartAttempts: number;
  maxRestartAttempts: number;
}

export class KeroUnavailableError extends Error {
  constructor() {
    super("El motor de captura no está disponible. Reintentá el arranque o reiniciá la app.");
    this.name = "KeroUnavailableError";
  }
}

export async function ensureKeroAvailable(): Promise<void> {
  const status = await window.electronAPI?.getKeroStatus?.();
  if (status && status.state !== "running" && status.state !== "external") {
    throw new KeroUnavailableError();
  }
}

export async function retryKero(): Promise<void> {
  const status = await window.electronAPI?.restartKero?.();
  if (!status || (status.state !== "running" && status.state !== "external")) {
    throw new KeroUnavailableError();
  }
}
